


import { AnimatePresence, motion } from "framer-motion";
// import GenerarActa from "../../../screens/Actas/Acta/Proceso/GenerarActa";
import useMeasure from "react-use-measure";
// import { useActaDetalleStore } from "../../../store/actaDetalleStore";
import { Alert, Button } from "react-bootstrap";
import React from "react";

import { Modal, MuniSpinner2 } from "../../../../components";
import { useGeneralAppStore } from "../../../../store/generalAppStore";
import { useActasStore } from "../../../../store/actasStore";
import { useActas } from "../../../../hooks/useActas";
import { useActaDetalleStore } from "../../../../store/actaDetalleStore";


const ModalActasSinEntregar = ({ ampReparto, setActasAImprimir, setRefetch }) => {

    //? ESTADOS GLOBALES
    const { loads, modals, handlerModal } = useGeneralAppStore();
    const { setActaDetalle } = useActasStore();
    const { acta } = useActaDetalleStore();
    const { imprimirActas, asignarActasANotificador, marcarActasSinEntregar } = useActas();
    // const { actaDetalle } = useActaDetalleStore()

    // const { acta } = actaDetalle;
    const [ref, bounds] = useMeasure();
    // console.log(loads)
    return (
        <>
            <Modal
                backdrop={true}
                show={modals.includes('actas_sin_entregar')}
                size={"md"}
                onHide={() => handlerModal({ modal: false, modalName: "actas_sin_entregar" })}
                title={() => "Marcar actas sin entregar"}
            >
                <div className="position-relative">
                    <Alert>Informe al notificador para  no enviar las actas, que estan en reparto</Alert>

                    {
                        (loads.includes('asignar_notificador') || loads.includes('actas_sin_entregar')) &&
                        <div className="position-absolute h-100 w-100 top-0 z-3 d-flex justify-content-center align-items-center" style={{ backgroundColor: "rgba(255,255,255,0.7)" }}>
                            <MuniSpinner2 />
                        </div>
                    }
                    <div>
                        <p className="fw-bold text-primary text-center">Actas a cambiar</p>
                        <ul className="mb-0">
                            {
                                ampReparto?.map((acta) => {
                                    return (
                                        <React.Fragment key={acta.id}>
                                            <div className="row  ">
                                                <div className="col-12 col-sm-6 col-md-6 col-lg-6 p-0 m-0 fw-bold">
                                                    <p key={acta?.id}
                                                        className={`bg-warning px-2 rounded pt-1 text-dark fw-bold m-0 `}
                                                        style={{ width: "fit-content" }}
                                                    >
                                                        Acta - {acta?.numero_acta}
                                                    </p>
                                                </div>
                                                <p className="col-12 col-sm-6 col-md-6 col-lg-6 p-0 m-0 fw-bold">Fecha: <span className="fw-normal "> {acta.fecha_hora}</span></p>
                                                {
                                                    acta?.documento &&
                                                    <p className="col-12 col-sm-6 col-md-6 col-lg-6 p-0 m-0 fw-bold">DNI: <span className="fw-normal "> {acta.documento}</span></p>
                                                }
                                                {
                                                    acta?.infraccion &&
                                                    <p className="col-12 col-sm-6 col-md-6 col-lg-6 p-0 m-0 fw-bold">Tipo: <span className="fw-normal "> {acta.infraccion}</span></p>
                                                }
                                            </div>
                                            <hr className="m-2" />
                                        </React.Fragment>
                                    )
                                })
                            }
                        </ul>

                    </div>
                    <Alert variant="warning">
                        <p className="mx-auto w-100 text-center m-0 bg-white p-3"><b>Motivo:</b> Pedido no entregar</p>
                    </Alert>

                    <section className="w-100 d-flex justify-content-end gap-2">
                        <Button size="sm"
                            onClick={() => {
                                marcarActasSinEntregar({ actas: ampReparto.map((acta) => acta.id), acta_detalle: acta?.id },
                                    acta,
                                    setRefetch)
                            }}>Confirmar</Button>
                        <Button size="sm" variant="danger" onClick={() => handlerModal({ modal: false, modalName: "actas_sin_entregar" })}>Cancelar</Button>
                    </section>
                    <AnimatePresence>
                        <motion.div animate={{ height: bounds.height }} className="overflow-hidden">
                            estas seguro?
                        </motion.div>
                    </AnimatePresence>
                </div>



            </Modal>
        </>
    );
}
export default ModalActasSinEntregar;